/* eslint-disable */
<template>
  <div class="locations-and-countries">
    <AdminNavigation ref="navigation" indexProps="9"/>
    <div class="top-panel">
      <Header/>
      <div class="header-title-section">
        <div class="header-title"><h1>Countries</h1></div>
      </div>
    </div>
    <div class="panel">
      <AdminSettingsMenu indexProps="2-1"/>
      <div class="content">
        <div class="content-scroll-x">
          <div>
            <div>
              <table class="table">
                <thead>
                <tr>
                  <th style="width:20%" class="long-text">Country Name</th>
                  <th style="width:10%" class="long-text">Country Code</th>
                  <th style="width:55%" class="long-text">Country Description</th>
                  <th style="width:15%;vertical-align:middle" class="icon-col">
                    <div v-if="user.type >= 6" class="icon-group justify-content-center align-items-center">
                      <v-btn class="add-icon" @click="dialogVisible = true" dark>Add New</v-btn>
                    </div>
                  </th>
                </tr>
                </thead>
              </table>
            </div>
            <!-- <div :class="locations.length > 5 ? 'content-scroll-y' : ''"> -->
            <div>
              <table class="table">
                <tbody>
                <tr v-for="country in countries" :key="country.CountryID">
                  <td style="width:20%" class="long-text">{{ country.CountryName }}</td>
                  <td style="width:10%" class="long-text">{{ country.CountryCode }}</td>
                  <td style="width:55%" class="long-text">{{ country.CountryDescription }}</td>
                  <td style="width:15%; vertical-align:middle" class="icon-col">
                    <div class="icon-group justify-content-center align-items-center">
                      <img @click="currentObj=$_.cloneDeep(country); dialogVisible=true" data-toggle="tooltip" data-placement="right"
                           title="Edit Country" src="@/assets/images/edit_icon.svg"/>
                      <img v-if="user.type >= 6" data-toggle="tooltip" data-placement="right"
                           title="Delete Country" @click="showDelete(country)" src="@/assets/images/delete_icon.svg"/>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div v-if="totalCount > listParam.pageSize" class="pagination">
          Page
          <div class="pagination-group">
            <div class="border-icon pagination-current dropdown">
              <div class="pagination-current-text">{{ listParam.pageNum }}</div>
              <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true"
                   aria-expanded="false"></div>
              <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/listParam.pageSize))" :key="item"
                     :class="listParam.pageNum === item ? 'selected' : ''" :value="item" @click="selectPage(item)">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount / listParam.pageSize) }}</div>
        </div>
      </div>
    </div>
    <el-dialog
        class="edit-zoho-dialog"
        :title="currentObj.CountryID ? 'Edit Country' : 'Add Country'"
        :visible.sync="dialogVisible"
        @close="closeModal"
        width="50%">
      <div>
        <el-form ref="ruleForm" :model="currentObj" label-width="180px" :rules="rules">
          <el-form-item label="Country Name" prop="CountryName">
            <el-input v-model="currentObj.CountryName" maxlength="32"></el-input>
          </el-form-item>
          <el-form-item label="Country Code" prop="CountryCode">
            <el-input v-model="currentObj.CountryCode" maxlength="3"></el-input>
          </el-form-item>
          <el-form-item label="Country Description" prop="CountryDescription">
            <el-input type="textarea" v-model="currentObj.CountryDescription" maxlength="100" show-word-limit></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
    <v-btn class="white-button me-2" dark @click="dialogVisible = false">Cancel</v-btn>
    <v-btn dark :disabled="user.type < 6" :loading="loading" @click="submitForm('ruleForm')">Save</v-btn>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'
import AdminNavigation from '@/components/AdminNavigation'
import AdminSettingsMenu from '@/components/AdminSettingsMenu'
import Header from '@/components/Header'

export default {
  name: 'AdminLocationsAndRegions',
  components: {
    AdminNavigation,
    AdminSettingsMenu,
    Header,
  },
  data() {
    const countryNameValidator = (rule, value, callback) => {
      const s = String(value || '').trim()
      if (!s) {
        callback(new Error('Country Name is required.'))
        return
      }
      if (s.length > 32) {
        callback(new Error('Country Name must not exceed 32 characters.'))
        return
      }
      if (!/(?=.*[A-Za-z])/.test(s)) {
        callback(new Error('Country Name must include at least one English letter.'))
        return
      }
      if (!/^[A-Za-z\s-]+$/.test(s)) {
        callback(new Error('Country Name may only contain English letters, spaces, and hyphens (-).'))
        return
      }
      callback()
    }
    const countryCodeValidator = (rule, value, callback) => {
      const s = String(value || '').trim()
      if (!s) {
        callback(new Error('Country Code is required.'))
        return
      }
      if (s.length > 3) {
        callback(new Error('Country Code must not exceed 3 characters.'))
        return
      }
      if (!/^[A-Za-z]+$/.test(s)) {
        callback(new Error('Country Code may only contain English letters (A-Z, a-z).'))
        return
      }
      callback()
    }
    const countryDescriptionValidator = (rule, value, callback) => {
      const s = String(value || '').trim()
      if (!s) {
        callback()
        return
      }
      if (s.length > 100) {
        callback(new Error('Country Description must not exceed 100 characters.'))
        return
      }
      if (!/(?=.*[A-Za-z])/.test(s)) {
        callback(new Error('Country Description must include at least one English letter.'))
        return
      }
      if (!/^[A-Za-z\s\-()&]+$/.test(s)) {
        callback(new Error('Country Description may only contain English letters, spaces, hyphens (-), parentheses ( ), and ampersand (&).'))
        return
      }
      callback()
    }
    return {
      currentObj: {
        CountryName: '',
        CountryCode: '',
        CountryDescription: ''
      },
      rules: {
        CountryName: [
          {validator: countryNameValidator, trigger: ['blur', 'change']},
        ],
        CountryCode: [
          {validator: countryCodeValidator, trigger: ['blur', 'change']},
        ],
        CountryDescription: [
          {validator: countryDescriptionValidator, trigger: ['blur', 'change']},
        ],
      },
      loading: false,
      countries: [],
      dialogVisible: false,
      totalCount: 0,
      listParam: {
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/getUser'];
    },
  },
  methods: {
    closeModal() {
      this.$refs.ruleForm.resetFields()
      this.currentObj = {
        CountryName: '',
        CountryCode: '',
        CountryDescription: ''
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.currentObj.CountryName = String(this.currentObj.CountryName || '').trim()
          this.currentObj.CountryCode = String(this.currentObj.CountryCode || '').trim()
          this.currentObj.CountryDescription = String(this.currentObj.CountryDescription || '').trim()
          this.loading = true
          if (this.currentObj.CountryID) {
            const id = this.currentObj.CountryID
            const obj = {...this.currentObj}
            delete obj.CountryID
            utilities.putCountry(id, obj).then(() => {
              this.loading = false
              this.dialogVisible = false
              this.$notify({
                dangerouslyUseHTMLString: true,
                message: '<div class="alert-success">' +
                    '            <b>Success:</b> Country Updated !' +
                    '          </div>',
              });
              this.selectPage(1)
            }).catch(() => {
              this.loading = false
            })
          } else {
            utilities.postCountry(this.currentObj).then(() => {
              this.loading = false
              this.dialogVisible = false
              this.$notify({
                dangerouslyUseHTMLString: true,
                message: '<div class="alert-success">' +
                    '            <b>Success:</b> Country Created !' +
                    '          </div>',
              });
              this.selectPage(1)
            }).catch(() => {
              this.loading = false
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    selectPage(index) {
      this.listParam.pageNum = index
      this.getData()
    },
    showDelete(c) {
      this.$confirm({
        content: `Are you sure you wish to delete the country: ${c.CountryName}?`,
        onConfirm: () => {
          utilities.deleteCountry(c.CountryID).then(() => {
            this.$notify({
              dangerouslyUseHTMLString: true,
              message: '<div class="alert-success">' +
                  '            <b>Success:</b> Country Deleted !' +
                  '          </div>',
            });
            this.selectPage(1)
          })
        }
      })
    },
    async getData() {
      await this.$store.dispatch('loading/setLoadComponent', true)
      const {data, count} = await utilities.getCountries(this.listParam)
      this.countries = data
      this.totalCount = count
      await this.$store.dispatch('loading/setLoadComponent', false)
    }
  },
  async beforeMount() {
    await this.getData()
  },
  mounted() {
  },
}
</script>
<style>
</style>